<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择条码规则"
      top="5vh"
      width="1100px"
  >
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="snRule"
        @select="selectSnRule"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="规则编号" prop="snRuleNo">
            <el-input v-model.trim="filter.snRuleNo" placeholder="请输入规则编号" clearable/>
          </el-form-item>
          <el-form-item label="规则类型" prop="snType">
            <el-select v-model="filter.snType" placeholder="请选择规则类型" clearable>
              <el-option label="产品条码" :value="10"/>
              <el-option label="外箱条码" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="规则样式" prop="snRuleExpression">
            <el-input v-model.trim="filter.snRuleExpression" placeholder="请输入规则样式"/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          snRuleNo: "",
          snRuleExpression: "",
          snType: "",
        },
        columns: [
          {
            title: "规则编号",
            key: "snRuleNo",
            width: 100,
            align: "center",
          },
          {
            title: "规则类型",
            key: "snType",
            render: (h, params) => {
              return h("span", params.row.snType === 10 ? "产品条码" : "外箱条码");
            },
            width: 100,
            align: "center",
          },
          {
            title: "规则样式",
            key: "snRuleExpression",
            width: 240,
          },
          {
            title: "规则描述",
            key: "snRuleExpressionDesc",
            tooltip: true,
            minWidth: 600,
          },
          {
            title: "备注",
            key: "snRuleDesc",
            tooltip: true,
            minWidth: 320,
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        // 清空查询条件
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      // 选择工厂
      selectSnRule(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
